/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventGuid = {
    properties: {
        creation_number: {
            type: 'U64',
            isRequired: true,
        },
        account_address: {
            type: 'Address',
            isRequired: true,
        },
    },
} as const;
